export default {
  title: 'Roue',
  actions: {
    create: 'créer un roue',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette roue? ',
    delete: 'Supprimer',
    next: 'Suivant',
    cancel: 'Annuler',
    save: 'Sauvgarder'
  },
  empty: {
    title: 'Aucune roue',
    message: 'Pour créer une roue, rien de plus simple, il suffit de cliquer sur le lien suivant :'
  },
  create: {
    title: 'Créer une roue',
    fields: {
      name: 'Nom',
      date: {
        name: 'Date',
        start: 'Début',
        end: 'Fin'
      },
      where: 'Où'
    }
  },
  list: {
    name: 'nom',
    code: 'code',
    status: 'status',
    where: 'où',
    date: 'date',
    stats: 'statistique'
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/wheel.js